import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useThemeProps } from "@mui/material";
import { cloneElement, forwardRef, useEffect, useRef } from "react";
import { useSlotProps } from "../../../base/index.js";
import { useElementSize } from "../../../hooks/index.js";
import { useToolbarApi } from "../store/store.js";
import { useToolbarChildren } from "./hooks/useToolbarChildren.js";
import { toolbarRootName } from "./classes.js";
import { Root } from "./components/Root.js";
import { ToolbarRootContext } from "./context/ToolbarRootContext.js";
import { useToolbarCssStyles } from "./context/hooks/useToolbarCssStyles.js";
import { useToolbarCssVariables } from "./context/hooks/useToolbarCssVariables.js";
import { useToolbarStoreId } from "./context/hooks/useToolbarStoreId.js";
import { useUtilityClasses } from "./hooks/useUtilityClasses.js";
const Toolbar = forwardRef(function ToolbarRoot(inProps, ref) {
  const props = useThemeProps({
    name: toolbarRootName,
    props: inProps
  });
  const { children, className = "", components, componentsProps, sx, width, testId = `${toolbarRootName}-root` } = props;
  const ownerState = props;
  const railRef = useRef(null);
  const { width: calculatedWidth } = useElementSize(railRef.current);
  const { views, rail } = useToolbarChildren(children);
  const utilityClasses = useUtilityClasses(ownerState);
  const cssStyles = useToolbarCssStyles();
  const cssVariables = useToolbarCssVariables();
  const storeId = useToolbarStoreId();
  const { setWidth, setMetaRail } = useToolbarApi(storeId);
  useEffect(() => {
    setWidth(calculatedWidth);
  }, [calculatedWidth, setWidth]);
  useEffect(() => {
    if (railRef.current) {
      setMetaRail(railRef.current);
    }
  }, [setMetaRail]);
  const rootSlotProps = useSlotProps({
    className: `${className} ${utilityClasses.root}`,
    elementType: Root,
    externalSlotProps: componentsProps?.root,
    ownerState,
    additionalProps: {
      "data-testid": testId,
      "data-tidal": toolbarRootName,
      as: components?.Root,
      cssStyles,
      cssVariables,
      ref,
      sx
    }
  });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Root, { ...rootSlotProps, children: rail && cloneElement(rail, {
      width,
      ref: railRef
    }) }),
    views
  ] });
});
function ToolbarRoot2(props) {
  const { storeId, cssVarOverrides, ...toolbarProps } = props;
  return /* @__PURE__ */ jsx(ToolbarRootContext, { storeId, cssVarOverrides, children: /* @__PURE__ */ jsx(Toolbar, { ...toolbarProps }) });
}
export {
  ToolbarRoot2 as ToolbarRoot
};
//# sourceMappingURL=ToolbarRoot.js.map
